export default __webpack_public_path__ + "static/media/tick.9e814d0a.svg";